import { Header, HeroImage, HeroSection, SubHeader, HeroOverlay, Button, ButtonsWrapper, HeroWrapper, } from "./styled";
import DefaultHero480 from "./baner-480.webp";
import DefaultHero768 from "./baner-768.webp";
import DefaultHero1080 from "./baner-1080p.webp";
import DefaultHero1440 from "./baner-1440p.webp";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../config/links";

const Hero = ({
    id = LINKS.sections.home,
    variant = "main",
    images,
}) => {
    const { t } = useTranslation();

    const offset = window.innerWidth <= 768 ? -50 : -90;
    const key = `hero.${variant}`;

    const heroImages = images ?? {
        480: DefaultHero480,
        768: DefaultHero768,
        1080: DefaultHero1080,
        1440: DefaultHero1440,
    };

    const buttonsConfig = LINKS.heroButtons[variant] ?? [];
    const buttonsText = t(`${key}.buttons`, { returnObjects: true });
    const heroButtonsText = Array.isArray(buttonsText) ? buttonsText : [];

    return (

        <HeroSection id={id}>

            <picture>
                <source
                    type="image/webp"
                    srcSet={`${heroImages[480]} 480w, ${heroImages[768]} 768w, ${heroImages[1080]} 1080w, ${heroImages[1440]} 1440w`}
                    sizes="100vw"
                />
                <HeroImage
                    src={heroImages[1080]}
                    srcSet={`${heroImages[480]} 480w, ${heroImages[768]} 768w, ${heroImages[1080]} 1080w, ${heroImages[1440]} 1440w`}
                    sizes="100vw"
                    alt={t(`${key}.alt`)}
                    loading="eager"
                    fetchPriority="high"
                    decoding="async"
                    width="1920"
                    height="1080"
                />
            </picture>

            <HeroOverlay>
                <HeroWrapper>
                    <Header>{t(`${key}.title`)}</Header>

                    <SubHeader>{t(`${key}.subtitle`)}</SubHeader>


                    {buttonsConfig.length > 0 && (
                        <ButtonsWrapper>
                            {buttonsConfig.map((button, index) => (
                                <Button
                                    key={button.key}
                                    to={button.to}
                                    smooth
                                    duration={600}
                                    offset={offset}
                                >
                                    {heroButtonsText[index]?.label}
                                </Button>
                            ))}
                        </ButtonsWrapper>

                    )}
                </HeroWrapper>
            </HeroOverlay>

        </HeroSection >
    );
};

export default Hero;